import api from './api';

export function isUnidadeAtendimentoValida(idPa: number) {
  return api.get(`pontoAtendimento/public/pode-venda-simplificada/${idPa}`);
} 
